import React from "react";
import "./pvxAdmin.css";

import SideNav from "../Components/sideNav";
import Navbar from "../Components/navbar";
import StatCards from "../Components/statCards";
import Performance from "./performance";
import BigBar from "../Components/bigBar";
import SmallBar from "../Components/smallBar";
import DonutChart from "../Components/donutChart";
import UnderChartFull from "./underChartFull";

const PvxAdmin = () => {
  const statCardData = [
    {
      body: "$12,750",
      head: "Revenue",
      icon: "./images/PvxDashboard/StatCard/Dollar.svg",
    },
    {
      body: "3000",
      head: "Active Users",
      icon: "./images/PvxDashboard/StatCard/Users.svg",
    },
    {
      body: "70000",
      head: "Total Projects",
      icon: "./images/PvxDashboard/StatCard/Docs.svg",
    },
    {
      body: "4000",
      head: "Subscriptions",
      icon: "./images/PvxDashboard/StatCard/Subs.svg",
    },
    {
      body: "100",
      head: "Total Queries",
      icon: "./images/PvxDashboard/StatCard/Queries.svg",
    },
  ];

  const values = [
    {
      name: "No of Admin Logins",
      value: "1000",
    },
    {
      name: "No of Designer Logins",
      value: "100000",
    },
    {
      name: "No of Total Projects Created",
      value: "100000",
    },
    {
      name: "No of Total Incomplete Projects",
      value: "100000",
    },
    {
      name: "Average Simulation Time /Project",
      value: "100000",
    },
  ];

  return (
    <div className="pvxAdminColor">
      <Navbar />
      <SideNav active="admin" />
      <div className="pvxAdmin">
        <StatCards statCardData={statCardData} />
        <div className="b2">
          <Performance values={values} title="System Performance" />
          <BigBar dropdown={true} title="No of Simulations Completed" />
        </div>
        <div className="b2">
          <SmallBar color="#EF9029" title="No of Active Users" dropdown={true} />
          <Performance values={values} title="User Engagement" height="345px" />
          <DonutChart values={values} title="Customer Support" height="345px" />
        </div>
        <div className="b2">
          <UnderChartFull />
          <Performance values={values} title="Financial Overview" height="345px" />
        </div>
      </div>
    </div>
  );
};

export default PvxAdmin;
